import { FormField } from '@components/admission-modal/admission/admission.type';

export const formatFormFieldsToBackend = ({ formFields }: { formFields: FormField[] }) =>
  formFields
    .filter((field) => field.isRequired)
    .map(({ name, dataType, isRequired, max, min }) => ({
      name,
      dataType,
      isRequired,
      max: max ? Number(max) : undefined,
      min: min || min === 0 ? Number(min) : undefined,
    }));
